import React from "react";
import * as yup from "yup";
import {ListEditor} from "../../components/list-editor";
import {
    AmbientType,
    AmbientTypeQueryQuery,
    useAmbientTypeQueryQuery,
    useAmbientTypesMutationMutation
} from "../../generated/graphql";
import {useLocation} from "react-router";
import {uniqueId} from "../../utils";

const columns = [{
    header: 'Name',
    accessor: 'name',
    dataType:'text'
}
];

function newRow():AmbientType {
    return {
        id: uniqueId(),
        name: ''
    }
}

const schema =  yup.array().of(
        yup.object().shape({
        'name': yup.string().required()
    })
);

function getValues(data:AmbientTypeQueryQuery):AmbientType[] {
    return data?.ambientTypes??[];
}


function AmbientTypes() {
    const query = useAmbientTypeQueryQuery();
    const [mutation,mutationResult] = useAmbientTypesMutationMutation();
    const url = useLocation().pathname;
    return (
        <ListEditor
            saveResult={mutationResult}
           columns={columns}
           validationSchema={schema}
            title="Ambient Types"
            mutation={mutation}
            query={query}
            permission="ambienttypes"
            newRow={newRow}
            newRowLabel="Add Ambient Type"
            baseUrl={url}
            getValues={getValues}
            className="other-types"
        />);
}

export default AmbientTypes;
